var _path, _circle, _path2, _circle2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3211 16.7934C11.0219 15.9561 10.3628 15.2163 9.44595 14.6887C8.52908 14.161 7.40567 13.875 6.24997 13.875C5.09427 13.875 3.97087 14.161 3.05399 14.6887C2.13712 15.2163 1.47801 15.9561 1.17889 16.7934",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.24999,
    cy: 8.62499,
    r: 2.62499,
    stroke: "#333333",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8211 16.7934C21.5219 15.9561 20.8628 15.2163 19.946 14.6887C19.0291 14.161 17.9057 13.875 16.75 13.875C15.5943 13.875 14.4709 14.161 13.554 14.6887C12.6371 15.2163 11.978 15.9561 11.6789 16.7934",
    stroke: "#333333",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 8.62499,
    r: 2.62499,
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.43efb1d73693816127b3c70cf0e6282f.svg";
export { ForwardRef as ReactComponent };